import {
  BlockAuthForm,
  type BlockAuthFormProps,
} from "@-/dev.improve.haniverse.components.ui.block-auth-form";
import { renderAuthSocialSignIn } from "@-/dev.improve.haniverse.routes.nav.app.auth._components.social-sign-in";

export type AuthBlockAuthFormProps = Omit<BlockAuthFormProps, "renderSocialConnections">;

/**
 * Auth-route `BlockAuthForm` that wires Apple / Google social sign-in buttons.
 * Route packages should import this instead of the presentational UI package so
 * social button `_components` stay encapsulated under `auth`.
 */
export function AuthBlockAuthForm(props: AuthBlockAuthFormProps) {
  return <BlockAuthForm {...props} renderSocialConnections={renderAuthSocialSignIn} />;
}
